"use client";

import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import NavList from "../NavList";
import { updateAdminProfile } from "../../../api/api";
import { useAuth } from "../../../context/AuthContext"; 

const AccountSettingsForm = () => {
  const { user, updateUser } = useAuth(); // get user from AuthContext

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    country: "",
    organization_name: "",
    organization_website: "",
    profile_picture: null,
  });

  const [preview, setPreview] = useState("/images/user-70.png");
  const [loading, setLoading] = useState(false);

  // Sync form with AuthContext user
  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        address: user.address || "",
        country: user.country || "",
        organization_name: user.organization_name || "",
        organization_website: user.organization_website || "",
        profile_picture: null,
      });
      setPreview(user.profile_picture || "/images/user-70.png");
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files && files[0]) {
      setForm({ ...form, profile_picture: files[0] });
      setPreview(URL.createObjectURL(files[0]));
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        if (form[key] !== null && form[key] !== "") {
          formData.append(key, form[key]);
        }
      });

      const res = await updateAdminProfile(formData);

      alert("Profile updated successfully!");

      if (res.profile_picture) setPreview(res.profile_picture);

      // Update AuthContext so all fields persist
      if (res.user) updateUser(res.user);
    } catch (err) {
      console.error(err);
      alert("Failed to update profile.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-4 rounded-3 mb-4">
      <NavList />

      <div className="mb-4">
        <h4 className="fs-20 mb-1">Profile</h4>
        <p className="fs-15">Update your photo and personal details here.</p>
      </div>

      <Form onSubmit={handleSubmit}>
        <Row>
          <Col lg={6}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Full Name</label>
              <Form.Control
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col lg={6}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Email Address</label>
              <Form.Control
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col lg={6}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Phone</label>
              <Form.Control
                type="text"
                name="phone"
                value={form.phone}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col lg={6}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Address</label>
              <Form.Control
                type="text"
                name="address"
                value={form.address}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col lg={6}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Country</label>
              <Form.Select
                name="country"
                value={form.country}
                onChange={handleChange}
              >
                <option value="">Select Country</option>
                <option value="Switzerland">Switzerland</option>
                <option value="Bangladesh">Bangladesh</option>
                <option value="United States">United States</option>
                <option value="Canada">Canada</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col lg={6}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Organization Name</label>
              <Form.Control
                type="text"
                name="organization_name"
                value={form.organization_name}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col lg={6}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Organization Website</label>
              <Form.Control
                type="url"
                name="organization_website"
                value={form.organization_website}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col lg={12}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Profile Picture</label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleChange}
              />
              {preview && (
                <img
                  src={preview}
                  alt="profile"
                  className="mt-3 rounded-circle"
                  width={75}
                  height={75}
                />
              )}
            </Form.Group>
          </Col>

          <Col lg={12} className="d-flex gap-3">
            <button
              type="button"
              className="btn btn-danger py-2 px-4"
              onClick={() => setForm({ ...form, profile_picture: null })}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary py-2 px-4"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Profile"}
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AccountSettingsForm;